import React from 'react';
import { useCheckoutGeo } from '../hooks/useCheckoutGeo';
import { checkoutGeoipUi } from '../constants/checkoutV2Locales';

export function CheckoutGeoipInfo({ locale = 'en' } = {}) {
  const { loading, payload } = useCheckoutGeo();
  const geo = checkoutGeoipUi(locale);

  const ip = payload?.ip || null;
  const location = payload?.location || {};
  const locationParts = [location.city, location.region, location.country]
    .filter(Boolean);

  if (loading) {
    return (
      <div className="checkout-geoip-info" aria-live="polite">
        {geo.loading}
      </div>
    );
  }

  const locationSegment =
    locationParts.length > 0
      ? `${geo.locationPrefix}${locationParts.join(', ')}`
      : null;

  const segments = [];
  if (ip) {
    segments.push(`${geo.ipPrefix}${ip}`);
  }
  if (locationSegment) segments.push(locationSegment);
  const line = segments.join(' · ');

  if (!line) {
    return null;
  }

  return (
    <div className="checkout-geoip-info" aria-live="polite">
      {line}
    </div>
  );
}
